import React from "react";
import OwnerIndexList from "containers/owner/OwnerIndexList";
import { Modal } from "react-bootstrap";
import { createElementIdFactory } from "utils/elementIds";

function OwnerIndexModal({
    user,
    onClose,
    data = [],
    ownerid,
    updateTableState,
    saveRecord,
    show,
}) {
    const createId = createElementIdFactory("owner-index-modal");

    return (
        <Modal id={createId("modal")} show={show} onHide={onClose} size="xl" centered>
            <Modal.Header id={createId("header")} closeButton>
                <Modal.Title>Owner Index</Modal.Title>
            </Modal.Header>
            <Modal.Body id={createId("body")}>
                <OwnerIndexList
                    controlType="table"
                    user={user}
                    data={data}
                    ownerid={ownerid}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                />
            </Modal.Body>
        </Modal>
    );
}
export default OwnerIndexModal;